<template>
   <LoadingPage v-if="isLoading"></LoadingPage>
   <div class="contracts-page p-3">
      <!-- ── Page Header ── -->
      <div class="ms-page-header">
         <div class="ms-page-header__content d-flex justify-content-between align-items-center flex-wrap gap-3 w-100">
            <div class="d-flex align-items-center gap-3">
               <div class="ms-page-header__icon">
                  <i class="fa-solid fa-file-signature"></i>
               </div>
               <div>
                  <p class="ms-page-header__breadcrumb">Sales Pipeline <span class="ms-breadcrumb-sep">/</span> Contracts</p>
                  <div class="d-flex align-items-center flex-wrap gap-3 mt-1">
                     <h1 class="ms-page-header__title">Contracts</h1>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="card">
         <div class="card-body m-2">
         <div class="row p-2 align-items-center">
            <div class="col-12 col-lg-3 mb-2 mb-lg-0">
               <input v-model.trim="search" type="text" class="form-control form-control-sm"
                  placeholder="🔍 Search organisation..."
                  style="border-radius:8px; height: 40px; font-size: 14px; font-family: 'Roboto', sans-serif; font-weight: 400;"
                  @keyup="onSearch()" />
            </div>

            <div class="col-12 col-lg-auto d-flex mb-2 mb-lg-0">
            </div>

            <div class="col-12 col-lg d-flex flex-wrap justify-content-lg-end align-items-center">
               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Sort by:</span>
                  <select v-model="sortBy" class="form-select shadow-none filterOptions bordered-select">
                     <option v-for="sortBy in sortByList" :value="sortBy.value" :key="sortBy.value">{{ sortBy.text }}
                     </option>
                  </select>
               </div>
               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Rows per page:</span>
                  <select v-model="pagination.pageSize" class="form-select form-select-sm shadow-none filterOptions bordered-select">
                     <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}
                     </option>
                  </select>
               </div>
               <div class="pagination">
                  <button @click="previousPage()" :disabled="pagination.page === 1" class="pagination-arrow">
                     <i class="fas fa-chevron-left"></i>
                  </button>
                  <span class="pagination-label">
                     <strong>{{ paginationLabel }}</strong> of {{ pagination.totalItems }}
                  </span>
                  <button @click="nextPage()" :disabled="pagination.page === pagination.totalPages || pagination.totalItems === 0" class="pagination-arrow">
                     <i class="fas fa-chevron-right"></i>
                  </button>
               </div>
            </div>
         </div>

         <!-- Filters Section -->
         <div class="row p-2 pt-0 align-items-center">
            <div class="col-12 d-flex flex-wrap align-items-center gap-2">
               <!-- Status Filter Dropdown -->
               <div class="dropdown">
                  <button type="button" class="btn custom-filter-dropdown-btn btn-sm fw-bold"
                     style="height: 35px; border-radius: 8px !important; display: inline-flex; align-items: center;"
                     data-bs-toggle="dropdown" aria-expanded="false">
                     Status
                     <i class="fa-solid fa-filter ms-2" style="font-size: 12px; color: #00A0C1;"></i>
                     <span v-if="statusFilter.length > 0" class="badge ms-2 rounded-pill text-white" style="font-size: 10px; background-color: #00A0C1 !important;">
                        {{ statusFilter.length }}
                     </span>
                  </button>
                  <div class="dropdown-menu p-2" style="min-width: 220px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" @click.stop>
                     <div class="d-flex flex-column gap-2 w-100" style="max-height: 250px; overflow-y: auto;">
                        <div v-for="opt in statusOptions" :key="opt.value" class="d-flex align-items-center mb-1">
                           <label class="d-flex align-items-center cursor-pointer mb-0 w-100">
                              <input class="custom-checkbox-input" type="checkbox" :id="'contract-status-' + opt.value" :value="opt.value" v-model="statusFilter">
                              <span class="custom-checkbox"></span>
                              <span class="ms-2 select-none" style="font-size: 14px; font-weight: 500; color: #495057;">{{ opt.text }}</span>
                           </label>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Lead Filter Dropdown -->
               <div class="dropdown">
                  <button type="button" class="btn custom-filter-dropdown-btn btn-sm fw-bold"
                     style="height: 35px; border-radius: 8px !important; display: inline-flex; align-items: center;"
                     data-bs-toggle="dropdown" aria-expanded="false">
                     Organisation
                     <i class="fa-solid fa-filter ms-2" style="font-size: 12px; color: #00A0C1;"></i>
                     <span v-if="leadFilter.length > 0" class="badge ms-2 rounded-pill text-white" style="font-size: 10px; background-color: #00A0C1 !important;">
                        {{ leadFilter.length }}
                     </span>
                  </button>
                  <div class="dropdown-menu p-2" style="min-width: 250px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" @click.stop>
                     <div class="d-flex flex-column gap-2 w-100" style="max-height: 250px; overflow-y: auto;">
                        <div v-for="(l, idx) in leads" :key="l.id || idx" class="d-flex align-items-center mb-1">
                           <label class="d-flex align-items-center cursor-pointer mb-0 w-100">
                              <input class="custom-checkbox-input" type="checkbox" :id="'contract-lead-' + (l.id || idx)" :value="l.id" v-model="leadFilter">
                              <span class="custom-checkbox"></span>
                              <span class="ms-2 select-none" style="font-size: 14px; font-weight: 500; color: #495057;">
                                 {{ l.organisation_name || `${l.first_name} ${l.last_name}` }}
                              </span>
                           </label>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Active Filters Chips -->
               <div v-if="statusFilter.length > 0 || leadFilter.length > 0" class="d-flex flex-wrap gap-2 align-items-center ms-3">
                  <span class="small text-muted fw-bold">Active Filters:</span>
                  <!-- Status Chips -->
                  <span v-for="val in statusFilter" :key="'status-' + val" class="badge bg-info text-white p-2 d-inline-flex align-items-center gap-1" style="border-radius: 20px; font-size: 12px; font-weight: 500; background-color: #00A0C1 !important;">
                     {{ getStatusText(parseInt(val, 10)) }}
                     <i class="fa-solid fa-xmark cursor-pointer ms-1" style="font-size: 10px;" @click="removeStatusFilter(val)"></i>
                  </span>
                  <!-- Lead Chips -->
                  <span v-for="val in leadFilter" :key="'lead-' + val" class="badge bg-info text-white p-2 d-inline-flex align-items-center gap-1" style="border-radius: 20px; font-size: 12px; font-weight: 500; background-color: #00A0C1 !important;">
                     {{ getLeadDisplayName(val) }}
                     <i class="fa-solid fa-xmark cursor-pointer ms-1" style="font-size: 10px;" @click="removeLeadFilter(val)"></i>
                  </span>
                  <button type="button" class="btn btn-link btn-sm text-decoration-none p-0 ms-2" style="font-size: 12px; color: #00A0C1;" @click="clearFilter()">Clear All</button>
               </div>
            </div>
         </div>
         <div class="row p-2">
            <table class="table align-middle mainTable">
               <thead class="align-middle">
                  <tr>
                     <th scope="col" v-for="header in headers" :key="header.value">{{ header.text }}</th>
                  </tr>
               </thead>

               <TableEmptyState
                  v-if="this.pagination.totalItems <= 0"
                  :colspan="headers.length"
                  icon="fa-solid fa-file-signature"
                  title="No Contracts Found"
                  description="Contracts will appear here automatically once proposals are accepted or generated for your clients."
                  :show-action="false"
                  :is-filtered="isFiltered"
                  filtered-title="No Matching Contracts Found"
                  filtered-description="No contracts match your current search query or active filter criteria. Try adjusting or clearing your filters."
                  clear-filters-text="Reset Filters & Search"
                  @clear-filters="clearAllFiltersAndSearch"
               />

               <tbody v-else>
                   <tr v-for="(contract) in contracts" :key="contract.id" class="clickable-row" title="Click to open in new tab" @click="openContractInNewTab(contract.id)">
                      <td :style="getContractSigners(contract).length > 1 ? 'border-left: 3px solid #6f42c1; padding-left: 12px;' : ''"
                          :title="getContractSigners(contract).length > 1 ? 'Multi-Signer Contract' : 'Click to open in new tab'">
                         <span class="spark-pill-badge"
                            :class="getVersionBadgeClass(contract.contract_version)">
                            <i class="fa-solid fa-code-branch"></i>
                            {{ contract.contract_version }}
                         </span>
                      </td>
                      
                      <td>
                           <div class="d-flex flex-column align-items-center gap-1">
                              <div class="d-flex align-items-center justify-content-center flex-wrap gap-1">
                                 <span class="spark-pill-badge"
                                     :class="getContractStatusBadgeClass(contract.contract_status)">
                                     <i :class="getContractStatusIcon(contract.contract_status)"></i>
                                     {{ getStatusText(contract.contract_status) }}
                                 </span>
                                 <span v-if="contract.has_revision_not_sent" class="spark-pill-badge spark-pill-badge--unsent-edits" title="Unsent edits or resolved revisions are pending.">
                                    <i class="fa-solid fa-triangle-exclamation"></i> Unsent Edits
                                 </span>
                                 <span v-if="contract.unresolved_revisions_count > 0" 
                                       class="spark-pill-badge spark-pill-badge--unresolved" 
                                       :title="`${contract.unresolved_revisions_count} Unresolved client revision${contract.unresolved_revisions_count > 1 ? 's' : ''}`">
                                    <i class="fa-solid fa-pen-to-square"></i> {{ contract.unresolved_revisions_count }}
                                 </span>
                              </div>
                           </div>
                        </td>

                      <td>
                         <span>
                            {{ 
                               (contract.contract_acceptance != undefined && contract.contract_acceptance.organisation_name != undefined && contract.contract_acceptance.organisation_name != "") 
                               ? contract.contract_acceptance.organisation_name 
                               : ((contract.Lead != undefined && contract.Lead.organisation_name != undefined && contract.Lead.organisation_name != "") ? contract.Lead.organisation_name : "No Org Name Set") 
                            }}
                         </span>
                         <div v-if="contract.Lead && contract.Lead.original_organisation_name && contract.Lead.original_organisation_name !== '' && contract.Lead.original_organisation_name !== ((contract.contract_acceptance && contract.contract_acceptance.organisation_name) ? contract.contract_acceptance.organisation_name : contract.Lead.organisation_name)" class="text-muted fst-italic mt-1" style="font-size: 11px;">
                            <i class="fa-solid fa-history me-1"></i>Formerly: <strong>{{ contract.Lead.original_organisation_name }}</strong>
                         </div>
                      </td>

                     <td :class="getStatusClass(formatDate(contract.sent_at), 1)">
                        {{ formatDate(contract.sent_at) || "Not Sent" }}
                     </td>

                     <td :class="getStatusClass(formatDate(contract.accepted_at), 4)">
                        {{ formatDate(contract.accepted_at) || "-" }}
                     </td>

                      <td>
                         <div class="d-flex flex-column gap-2" style="font-size: 12px; min-width: 160px; text-align: left; align-items: flex-start;">
                            <div v-for="(signer, idx) in getContractSignersDetails(contract)" :key="idx" 
                                 class="d-flex align-items-start gap-2">
                               <i v-if="signer.has_signed" 
                                  class="fa-solid fa-circle-check mt-1" 
                                  style="color: #2cce7d; font-size: 14px;"></i>
                               <i v-else-if="contract.contract_status === 1 || contract.contract_status === 2" 
                                  class="fa-solid fa-clock mt-1" 
                                  style="color: #ff9800; font-size: 14px;"></i>
                               <i v-else 
                                  class="fa-solid fa-clock mt-1" 
                                  style="color: #9e9e9e; font-size: 14px;"></i>
                               <div class="d-flex flex-column leading-normal">
                                  <span style="font-weight: 600; color: #2c3e50;">{{ signer.name }}</span>
                                  <span style="font-size: 10px; color: #7f8c8d;">{{ signer.email }}</span>
                               </div>
                            </div>
                            <span v-if="getContractSignersDetails(contract).length === 0" class="text-muted text-center w-100">-</span>
                         </div>
                      </td>

                     <td @click.stop>
                        <div class="action-button-container">
                           <div style="position: relative; display: inline-block;">
                              <button type="button" class="btn-svg-icon" title="Click to preview and edit contract"
                                 @click="onButtonClick('view-edit', contract.id)">
                                 <img src="@/assets/img/icons/universal_edit.svg" alt="Edit" class="icon-svg" />
                              </button>
                              <span v-if="unreadContractIds.includes(contract.id)" title="Unread messages" 
                                 style="position: absolute; top: 0px; right: 0px; width: 10px; height: 10px; background-color: #e53935; border-radius: 50%; border: 2px solid white; pointer-events: none;"></span>
                           </div>

                           <button :disabled="contract.contract_status == 4 || contract.contract_status == 5" v-if="!this.$store.state.auth.isGeneralUser && this.$store.getters['auth/canSendProposal']" type="button" class="btn-svg-icon"
                              :title="(contract.contract_status == 4) ? 'Contract is already executed' : (contract.contract_status == 5) ? 'Contract is cancelled' : 'Click to send'"
                              @click="onButtonClick('send', contract); openSendModal();">
                              <img src="@/assets/img/icons/send.svg" alt="Send" class="icon-svg" />
                           </button>

                           <button type="button" class="btn-svg-icon" title="View Client Contract Page"
                              @click="onButtonClick('view-client', contract)">
                              <img src="@/assets/img/icons/Landingpage.svg" alt="View Client Contract"
                                 class="icon-svg" />
                           </button>

                           <button type="button" class="btn-svg-icon" title="View Activity Log"
                              @click="onButtonClick('activity-log', contract.id)">
                              <img src="@/assets/img/icons/actlog.svg" alt="Activity Log" class="icon-svg" />
                           </button>

                           <button type="button" class="btn-svg-icon btn-svg-icon--delete" :title="(contract.contract_status != 0)?'Cannot cancel a sent contract':'Click to mark as cancelled'"
                              @click="onButtonClick('delete', contract.id)" :disabled="contract.contract_status != 0">
                              <img src="@/assets/img/icons/universal_cancel.svg" alt="Cancel" class="icon-svg" />
                           </button>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>

   <div class="modal fade" id="sendForm" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static" ref="sendForm"
      style="top: 2%;">
      <div ref="modalSendFormDialogRef" class="modal-dialog modal-dialog-scrollable">
         <div class="modal-content">
            <div class="modal-header justify-content-end">
               <div>
                  <button ref="closeSendFormModal" type="button" class="btn-close" data-bs-dismiss="modal"
                     aria-label="Close"></button>
               </div>
            </div>

            <div class="modal-body">
               <SendForm ref="sendContractForm" :initialSendTo="contract_signer_emails" :contractID="contract_id" :hasEditor="false"
                  @contractSentSuccess="this.init(); this.$refs.closeSendFormModal.click(); this.getContractsList()" />
            </div>
         </div>
      </div>
   </div>

   <div class="modal fade" id="activityLogModal" ref="activityLogModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-scrollable">
         <div class="modal-content">
            <div class="modal-header activity-log-header">
               <h5 class="modal-title">Activity Log</h5>
               <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr class="modal-divider">

            <div class="modal-body">
               <ContractActivity ref="contractActivityRef" />
            </div>
         </div>
      </div>
   </div>

   <ConfirmModal
      v-model="showConfirmModal"
      :title="confirmModalTitle"
      :message="confirmModalMessage"
      @confirm="onConfirmAction"
   />
   </div>
</template>

<script>
import moment from "moment";
import { debounce, truncateLongText, log } from '@/plugins/helper.js'
import LoadingPage from '@/components/Utilities/vertex-loading.vue'
import 'vue-multiselect/dist/vue-multiselect.css'
import "@/assets/scss/vue-multiselect.scss";
import SendForm from '@/components/Contracts/SendForm.vue';
import { Modal } from 'bootstrap'; 
import ContractActivity from '@/components/Contracts/ContractActivity.vue';
import TableEmptyState from '@/components/Utilities/TableEmptyState.vue';

export default {
   components: {
      LoadingPage,
      SendForm,
      ContractActivity,
      TableEmptyState
   },

   data() {
      return {
         headers: [
            { text: "Version", value: "version" },
            { text: "Contract Status", value: "status" },
            { text: "Organisation", value: "organisation_name" },
            { text: "Date Sent", value: "date_sent" },
            { text: "Date Signed", value: "date_signed" },
            { text: "Signer/s", value: "signers" },
            { text: "Actions", value: "action" },
         ],
         search: "",
         leads: [],
         contracts: [],
         unreadContractIds: [],
         pagination: {
            pageSize: 10,
            page: 1,
            totalItems: 0,
            totalPages: 1,
         },
         rowsPerPageList: [
            { text: "5", value: 5 },
            { text: "10", value: 10 },
            { text: "20", value: 20 },
         ],
         sortByList: [
            { text: "Newest", value: "id_desc" },
            { text: "Oldest", value: "id_asc" },
         ],
         filterByList: [
            { text: "None", value: "" },
            { text: "Status", value: "status" },
         ],
         sortBy: "id_desc", 
         statusFilter: [],
         leadFilter: [],
         statusOptions: [
            { text: "Draft", value: "0" },
            { text: "Sent", value: "1" },
            { text: "Viewed", value: "2" },
            { text: "In Review", value: "3" },
            { text: "Executed", value: "4" },
            { text: "Cancelled", value: "5" },
            { text: "Pending Approval", value: "6" },
            { text: "Approved", value: "7" },
            { text: "Declined", value: "8" },
         ],
         filterByPriority: "none",
         filterByStatus: "none",
         sorting: {
            field: "id",
            order: "desc",
            filter: "none"
         },
         isEditing: false,
         debounceFn: null,
         leadStatusTypes: [],
         leadPriorityTypes: [],
         isLeadStatusContractSent: false,
         totalContracts: 0,
         markedForAuthCreationOption: {
            id: 'forCreationInAuth',
            name: 'Marked for creation in Auth'
         },
         authOrganisationsList: [],
         isViewSpamOnly: false,
         filtering: {
            field: "",
            value: "none"
         },
         filterBy: "status",
         isFilterByStatus: false,
         isLoading: false,
         colorPalette: [
            '#FF5733', '#33FF57', '#3357FF', '#FF33A1', '#A133FF', '#33FFF2', 
            '#FFC300', '#DAF7A6', '#C70039', '#900C3F', '#581845', '#FF8C00', 
            '#4CAF50', '#2196F3', '#9C27B0', '#FFEB3B', '#FF9800', '#795548'  
         ],
         colorForVersionIcon: {
            minor: "#FFA500",
            major: "#28a745",
            default: "#6c757d"
         },
         contract_signer_emails: [],
         contract_id: "",
         sendContractForm: null,
         showConfirmModal: false,
         confirmModalTitle: '',
         confirmModalMessage: '',
         pendingDeleteId: null,
         colorForStatus: {
            draft: '#F3994D', 
            sent: '#00a0c1',    
            viewed: '#8A2BE2',   
            in_review: '#FFD700', 
            executed: '#00A54F',
            cancelled: '#EB1C24',
            pending_approval: '#9C27B0',
            approved: '#00A54F'
         },
         vtxUsers: [],
      }
   },

   created() {
      this.init()
      this.debounceFn = debounce(() => this.getContractsList(), 500)
   },

   mounted() {
      this.sendContractForm = new Modal(this.$refs.sendForm);
      this.activityLogModalInstance = new Modal(this.$refs.activityLogModal); 

      window.addEventListener('contract-signed', this.handleContractSignedEvent);
   },

   beforeUnmount() {
      window.removeEventListener('contract-signed', this.handleContractSignedEvent);
   },

   computed: {
      isFiltered() {
         return (this.search && this.search.trim().length > 0) ||
                this.statusFilter.length > 0 ||
                this.leadFilter.length > 0;
      },

      paginationLabel() {
         var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
         var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)
         return start + " - " + end
      },
      currentPage() {
         return this.pagination.page
      },
      rowsPerPage() {
         return this.pagination.pageSize
      },
      sortItems() {
         return this.sortBy
      },
      filterByField() {
         return this.filterBy
      },
      filterItems() {
         if (this.filterBy == "priority") {
            return this.filterByPriority
         } else if (this.filterBy == "status") {
            return this.filterByStatus
         }
         return "none"
      },
   },

   watch: {
       'pagination.pageSize'() {
         this.pagination.page = 1
         this.getContractsList()
      },
      'pagination.page'() {
         this.getContractsList()
      },
      sortItems() {
         if (this.sortBy == "id_asc") {
            this.sorting.field = "id"
            this.sorting.order = "asc"
         } else if (this.sortBy == "id_desc") {
            this.sorting.field = "id"
            this.sorting.order = "desc"
         } else if (this.sortBy == "lead_name") {
            this.sorting.field = "organisation_name"
            this.sorting.order = "asc"
         } else if (this.sortBy == "priority" || this.sortBy == "status") {
            this.sorting.field = this.sortBy
            this.sorting.order = ""
         }
         this.sorting.filter = "none"
         this.getContractsList()
      },
      statusFilter: {
         handler() {
            this.pagination.page = 1
            this.getContractsList()
         },
         deep: true
      },
      leadFilter: {
         handler() {
            this.pagination.page = 1
            this.getContractsList()
         },
         deep: true
      },
      filterBy() {
         if (this.filterBy === "") {
            this.statusFilter = []
         }
         this.pagination.page = 1
         this.getContractsList()
      },
   },

   methods: {
      openSendModal() {
         this.sendContractForm.show();
         // Explicitly repopulate the form after the modal opens —
         // the watcher on initialSendTo won't fire if the value hasn't changed
         this.$nextTick(() => {
            if (this.$refs.sendContractForm) {
               this.$refs.sendContractForm.updateInitialSendTo(this.contract_signer_emails);
            }
         });
      },

      getVersionIconColor(versionNumber) {
         if (typeof versionNumber !== 'string' || !versionNumber.startsWith('v')) {
            return this.colorForVersionIcon.default;
         }
         const parts = versionNumber.slice(1).split('.');
         if (parts.length !== 2) {
            return this.colorForVersionIcon.default;
         }
         const minorStr = parts[1];
         const minor = parseInt(minorStr, 10);
         if (isNaN(minor) || minor.toString() !== minorStr) {
            return this.colorForVersionIcon.default;
         }
         if (minor > 0) {
            return this.colorForVersionIcon.minor;
         } else {
            return this.colorForVersionIcon.major;
         }
      },

      getColorFromName(name) {
         if (!name) {
            return '#6c757d';
         }
         let hash = 0;
         for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
         }
         const colorIndex = Math.abs(hash) % this.colorPalette.length;
         return this.colorPalette[colorIndex];
      },

      retrieveUserIcon(fullName) {
         let icon = "";
         if (fullName) {
            const nameParts = fullName.split(' ');
            if (nameParts.length > 0 && nameParts[0] !== '') {
               icon += nameParts[0].charAt(0);
            }
            if (nameParts.length > 1 && nameParts[1] !== '') {
               icon += nameParts[1].charAt(0);
            }
         }
         return icon.toUpperCase();
      },

      isContractSent(versionNumber) {
         if (typeof versionNumber !== 'string' || !versionNumber.startsWith('v')) {
            return false;
         }
         const parts = versionNumber.slice(1).split('.');
         if (parts.length !== 2) {
            return false;
         }
         const minorStr = parts[1];
         const minor = parseInt(minorStr, 10);
         if (isNaN(minor) || minor.toString() !== minorStr) {
            return false;
         }
         return minor <= 0;
      },

      getAcceptType(accept_code) {
         switch (accept_code) {
            case 1: {
               return "Yes"
            }
            default: return "TBD"
         }
      },

      formatCurrency(value) {
         const numericValue = parseFloat(value);
         if (isNaN(numericValue)) {
            return '$0.00';
         }
         return `$${numericValue.toFixed(2)}`;
      },

      truncateLongText(text, limit) {
         return truncateLongText(text, limit)
      },

      init() {
         this.getContractsList()
         this.getVertexUsers()
         this.getLeadsList()
      },

      async sendContract(id) {
         log("contract_id", id)
         await this.$axios.put("/contracts/" + id + "/send")
            .then((response) => {
               if (response.data.success) {
                  this.$toast.success(response.data.message)
                  this.getContractsList()
               } else {
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               log(error)
               this.$toast.error(error.response.data.message)
            })
      },

      onButtonClick(action, data) {
         if (action == "send") {
            this.contract_signer_emails = this.getContractSigners(data)
            this.contract_id = data.id
         } else if (action == "view-edit") {
            this.$router.push({ name: 'contract-view', params: { id: data } })
         } else if (action == "delete") {
            this.deleteContract(data)
         } else if (action == "view-client") {
            this.viewClientContract(data);
         } else if (action == "activity-log") {
            this.$refs.contractActivityRef.init(data); 
            this.activityLogModalInstance.show(); 
         }
      },

      openContractInNewTab(id) {
         const routeData = this.$router.resolve({ name: 'contract-view', params: { id: id } });
         window.open(routeData.href, '_blank');
      },

      viewClientContract(contract) {
         if (contract && contract.unique_key && contract.internal_key) {
            const routeData = this.$router.resolve({ name: 'clientContract', params: { unique_key: contract.unique_key, access_key: contract.internal_key } });
            window.open(routeData.href, '_blank');
         } else {
            this.$toast.error("Could not generate client link. Contract data is missing required keys.")
            console.error("Contract object is missing unique_key or internal_access_key", contract);
         }
      },

      async deleteContract(id) {
         this.pendingDeleteId = id;
         this.confirmModalTitle = 'Cancel Contract';
         this.confirmModalMessage = 'Do you want to mark this contract as cancelled?';
         this.showConfirmModal = true;
      },
      async onConfirmAction() {
         const id = this.pendingDeleteId;
         this.pendingDeleteId = null;
         if (!id) return;
         this.isLoading = true
         await this.$axios.delete("/contracts/" + id)
            .then((response) => {
               if (response.data.success) {
                  this.$toast.success(response.data.message)
                  this.getContractsList()
                  this.isLoading = false
               } else {
                  this.$toast.error(response.data.message)
                  this.isLoading = false
               }
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
               this.isLoading = false
            })
      },

      onToggleSidebar() {
         this.$refs.leadSidebarRef.addEventListener('hidden.bs.offcanvas', () => {
            this.$router.push({ name: 'leads' })
         });
      },

      onSearch() {
         this.pagination.page = 1
         this.debounceFn()
      },

      toggleContractUpload({ id }) {
         this.isLeadStatusContractSent = true
         this.$refs.leadContractsRef.showModal(this.$refs.leadContracts)
         this.$refs.leadContracts.addEventListener('hidden.bs.modal', () => {
            this.isLeadStatusContractSent = false
         });
         this.$refs.leadContractsRef.init(id)
      },

      handleContractSignedEvent(event) {
         console.log("[ContractsDashboard] Real-time contract-signed event received", event.detail);
         this.getContractsList();
      },

      async getContractsList() {
         this.isLoading = true
         let apiPath = "/contracts?pageSize=" + this.pagination.pageSize + "&page=" + this.pagination.page

         if (this.sortBy != "dateCreated_desc") {
            apiPath += "&sort=" + this.sorting.field
            if (this.sorting.order != "") {
               console.log(this.sorting.order)
               apiPath += "&order=" + this.sorting.order
            }
         }

         if (this.search != "") {
            apiPath += "&search=" + this.search
         }

         if (this.filterBy === "status" && this.statusFilter && this.statusFilter.length > 0) {
            apiPath += "&status=" + this.statusFilter.join(",")
         }

         if (this.leadFilter && this.leadFilter.length > 0) {
            apiPath += "&lead=" + encodeURIComponent(this.leadFilter.join(","))
         }

         await this.$axios.get(apiPath)
            .then((response) => {
               this.contracts = response.data.vertex_contracts || [];
               log(this.contracts)
               this.unreadContractIds = response.data.unread_comment_contract_ids || []
               this.pagination.totalItems = response.data.total_items
               this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize) || 1;
               this.isLoading = false
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
               this.isLoading = false
            })
      },

      getContractSigners(contract) {
         let signers = [];
         // Pull signers from contract acceptances (the actual signer records)
         if (contract.contract_acceptance && contract.contract_acceptance.signers && contract.contract_acceptance.signers.length > 0) {
            contract.contract_acceptance.signers.forEach(s => {
               if (s.email && !signers.includes(s.email)) {
                  signers.push(s.email);
               }
            });
         }
         // Fallback to shared users if no acceptance signers found
         if (signers.length === 0) {
            if (contract.shared_users && contract.shared_users.length > 0) {
               contract.shared_users.forEach(su => {
                  if (su.share_type === 'signer' && su.email && !signers.includes(su.email)) {
                     signers.push(su.email);
                  }
               });
            }
            // Final fallback to lead email
            if (signers.length === 0 && contract.Lead && contract.Lead.email) {
               signers.push(`${contract.Lead.email}`.trim());
            }
         }
         return signers;
      },

      getContractSignersDetails(contract) {
         let details = [];
         if (contract.contract_acceptance && contract.contract_acceptance.signers && contract.contract_acceptance.signers.length > 0) {
            contract.contract_acceptance.signers.forEach(s => {
               details.push({
                  name: s.name,
                  email: s.email,
                  has_signed: s.has_signed
               });
            });
         } else {
            // Fallback to shared users
            if (contract.shared_users && contract.shared_users.length > 0) {
               contract.shared_users.forEach(su => {
                  if (su.share_type === 'signer' && su.email) {
                     details.push({
                        name: su.signer_name || su.email,
                        email: su.email,
                        has_signed: contract.is_accepted
                     });
                  }
               });
            }
            // Final fallback to lead
            if (details.length === 0 && contract.Lead && contract.Lead.email) {
               details.push({
                  name: contract.Lead.organisation_name || `${contract.Lead.first_name} ${contract.Lead.last_name}`.trim() || contract.Lead.email,
                  email: contract.Lead.email,
                  has_signed: contract.is_accepted
               });
            }
         }
         return details;
      },

      formatDate(date) {
         if (!date || !moment(date).isValid() || moment(date).year() < 1980) {
            return null;
         }
         return moment(date).format("DD-MMM-YYYY")
      },

      formatTimestamp(date) {
         if (!date || !moment(date).isValid() || moment(date).year() < 1980) {
            return null;
         }
         return moment(date).format("DD-MMM-YYYY @ HH:mm:ss");
      },

      previousPage() {
         if (this.pagination.page > 1) { this.pagination.page-- }
      },

      nextPage() {
         if (this.pagination.page < this.pagination.totalPages) { this.pagination.page++ }
      },

      priorityClass(value) {
         let priority = this.leadPriorityTypes.filter((p) => { return p.id == value }).map((e) => e.name)
         return priority.toString().toLowerCase()
      },

      clearFilter() {
         this.statusFilter = []
         this.leadFilter = []
      },

      clearAllFiltersAndSearch() {
         this.search = '';
         this.statusFilter = [];
         this.leadFilter = [];
         this.pagination.page = 1;
         this.getContractsList();
      },

      removeStatusFilter(val) {
         this.statusFilter = this.statusFilter.filter(v => v !== val)
      },

      removeLeadFilter(val) {
         this.leadFilter = this.leadFilter.filter(v => v !== val)
      },

      async getLeadsList() {
         await this.$axios.get("/leads?pageSize=200")
            .then((response) => {
               this.leads = response.data.leads || []
            })
            .catch((error) => {
               console.error("Failed to load leads", error)
            })
      },

      getLeadDisplayName(uuid) {
         const lead = this.leads.find(l => l.id === uuid || l.uuid === uuid)
         if (!lead) return uuid
         if (lead.organisation_name) return lead.organisation_name
         return `${lead.first_name} ${lead.last_name}`
      },

      setFilterOptions(filter_field) {
         switch (filter_field) {
            case "priority": {
               this.filterValueOptions = [{
                  id: "none",
                  name: "All"
               }]
               this.leadPriorityTypes.forEach((s) => {
                  this.filterValueOptions.push({
                     id: s.id,
                     name: s.display_name,
                  })
               })
               return;
            }
            case "status": {
               this.filterValueOptions = [{
                  id: "none",
                  name: "All"
               }]
               this.leadStatusTypes.forEach((s) => {
                  this.filterValueOptions.push({
                     id: s.id,
                     name: s.display_name,
                  })
               })
               return;
            }
         }
      },

      getVertexAuthUser(id) {
         if (!this.vtxUsers || !Array.isArray(this.vtxUsers)) return "System Generated"
         let user = this.vtxUsers.find(user => user && user.id === id);
         if (user) {
            return user.first_name + " " + user.last_name
         } else if (user == null && id != "") {
            return "Deleted User"
         } else {
            return "System Generated"
         }
      },

      getVertexUsers() {
         this.vtxUsers = this.$store.state.auth.usersWithVertexRoles || []
      },

      getStatusColor(status_code) {
         switch (status_code) {
            case 0: return this.colorForStatus.draft;
            case 1: return this.colorForStatus.sent;
            case 2: return this.colorForStatus.sent; // Viewed is still blue-ish
            case 3: return "#F3994D"; // In Review color
            case 4: return "#28a745"; // Executed color
            case 8: return "#EB1C24"; // Declined color
            default: return this.colorForStatus.sent;
         }
      },

      getStatusText(status_code) {
         switch (status_code) {
            case 1: return "Sent";
            case 2: return "Viewed";
            case 3: return "In Review";
            case 4: return "Executed";
            case 5: return "Cancelled";
            case 6: return "Pending Approval";
            case 7: return "Approved";
            case 8: return "Declined";
            default: return "Draft";
         }
      },

      getVersionBadgeClass(versionNumber) {
         if (typeof versionNumber !== 'string' || !versionNumber.startsWith('v')) {
            return 'spark-pill-badge--version-default';
         }
         const parts = versionNumber.slice(1).split('.');
         if (parts.length !== 2) return 'spark-pill-badge--version-default';
         const minor = parseInt(parts[1], 10);
         if (isNaN(minor)) return 'spark-pill-badge--version-default';
         return minor > 0 ? 'spark-pill-badge--version-minor' : 'spark-pill-badge--version-major';
      },

      getContractStatusBadgeClass(statusCode) {
         switch (Number(statusCode)) {
            case 1: return 'spark-pill-badge--sent';
            case 2: return 'spark-pill-badge--viewed';
            case 3: return 'spark-pill-badge--in-review';
            case 4: return 'spark-pill-badge--executed';
            case 5: return 'spark-pill-badge--cancelled';
            case 6: return 'spark-pill-badge--pending-approval';
            case 7: return 'spark-pill-badge--approved';
            case 8: return 'spark-pill-badge--declined';
            default: return 'spark-pill-badge--draft';
         }
      },

      getContractStatusIcon(statusCode) {
         switch (Number(statusCode)) {
            case 1: return 'fa-solid fa-paper-plane';
            case 2: return 'fa-solid fa-eye';
            case 3: return 'fa-solid fa-hourglass-half';
            case 4: return 'fa-solid fa-file-signature';
            case 5: return 'fa-solid fa-ban';
            case 6: return 'fa-solid fa-clock-rotate-left';
            case 7: return 'fa-solid fa-check';
            case 8: return 'fa-solid fa-xmark';
            default: return 'fa-solid fa-pen';
         }
      },

      getStatusClass(value, type) {
         let base = "status-text"
         switch (type) {
            case 1: { 
               if (value === null) return base + " text-red"
            } break;
            case 2: {
               console.log("")
            } break;
            case 3: { 
               if (value === 0) { return base + " text-grey" }
            } break;
            case 4: {
               if (value === null) return base + " text-red"
            } break;
             case 5: {
               if (value === null) return base + " text-red"
            }
         }
         return base + " text-green"
      }
   }
}
</script>

<style scoped>
.filterTitle {
   font-weight: 500;
   color: #435666;
}
.filterOptions {
   font-weight: 500;
   color: #00A0C1;
}
.bordered-select {
   border: 1px solid #dee2e6 !important;
   border-radius: 8px !important;
   padding-top: 0.25rem;
   padding-bottom: 0.25rem;
   padding-left: 0.75rem;
   width: auto;
}
.pagination {
    display: inline-flex;
    align-items: center;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
}
.pagination-label {
    font-size: 0.9rem;
    color: #6c757d;
    font-weight: 500;
    padding: 0 8px;
    white-space: nowrap;
}
.pagination-label strong {
    color: #343a40;
}
.pagination-arrow {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #00A0C1;
    font-size: 1rem;
    padding: 8px 12px;
    transition: background-color 0.2s ease;
}
.pagination-arrow:hover:not(:disabled) {
    background-color: #f1f3f5;
}
.pagination-arrow:disabled {
    color: #ced4da;
    cursor: not-allowed;
}

.action-button-container {
   display: flex;
   align-items: center;
   justify-content: center;
   gap: 5px;
}

.btn-svg-icon {
   position: relative;
   width: 36px;
   height: 36px;
   border-radius: 50% !important;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   background-color: #e6f7fa;
   color: #00A0C1;
   border: none;
   padding: 0;
   cursor: pointer;
   transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}

.icon-svg {
   width: 30px;
   height: 30px;
   transition: filter 0.15s ease;
}

.icon-svg-fa {
   font-size: 16px;
   color: inherit;
   transition: color 0.15s ease;
}

.btn-svg-icon:hover:not(:disabled) {
   background-color: #00A0C1;
   color: #fff;
   transform: translateY(-1px);
   box-shadow: 0 4px 12px rgba(0, 160, 193, 0.25);
}

.btn-svg-icon:active:not(:disabled) {
   transform: translateY(0);
}

.btn-svg-icon:hover:not(:disabled) .icon-svg {
   filter: brightness(0) invert(1);
}

.btn-svg-icon:hover:not(:disabled) .icon-svg-fa {
   color: #fff !important;
}

.btn-svg-icon--delete {
   background-color: #fef2f2;
   color: #ef4444;
}

.btn-svg-icon--delete:hover:not(:disabled) {
   background-color: #ef4444;
   color: #fff;
   box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
}

.btn-svg-icon:disabled {
   cursor: not-allowed;
   opacity: 0.4;
   transform: none !important;
   box-shadow: none !important;
}

.high { color: #EB1C24; }
.low { color: #00A54F; }
.medium { color: #F3994D; }
.clickable-row { cursor: pointer; }
td { padding-top: 0 !important; padding-bottom: 0 !important; }

.table-select {
   padding-left: 5px;
   margin-right: 0;
   cursor: pointer;
   border: none;
   height: 45px;
   width: auto;
}
.table-select:not(.high, .low, .medium) { color: #435666; }
.table-select>option { color: #212529; }
.table-select:not(:hover) { background: none; }

.auth-org-select {
   padding: .375rem 2.25rem .375rem 5px;
   display: block;
   width: auto;
   font-size: 1rem;
   font-weight: 400;
   color: #435666;
   border: none;
   height: 45px;
   background: none;
   min-height: unset;
   text-align: start;
   align-items: center;
}

.auth-org-select .multiselect__tags {
   width: auto;
   height: auto;
   color: #435666;
   border: none;
   padding: .375rem 0 .375rem 0;
}

.auth-org-select .multiselect__placeholder,
.multiselect--active {
   width: auto;
   margin: 0px;
   padding: .375rem 0 .375rem 0;
   color: #435666;
}

.auth-org-select .multiselect__single {
   margin: 0px;
   padding: .375rem 0 .375rem 0;
   line-height: 1;
   width: auto;
}

.auth-org-select .multiselect__input {
   line-height: 1;
   padding: .375rem 0 .375rem 5px;
   margin: 0px;
}

td { text-align: center; }
th { text-align: center; }

.status-text { font-weight: 400; }
.text-red { color: #EB1C24 !important; }
.text-green { color: #00A54F !important; }
.text-orange { color: #F3994D !important; }
.text-grey { color: #435666 !important; }

.user-initials-icon {
   display: inline-flex;
   justify-content: center;
   align-items: center;
   width: 32px;
   height: 32px;
   border-radius: 50%;
   color: white;
   font-size: 14px;
   font-weight: bold;
   text-transform: uppercase;
   border: 1px solid rgba(255, 255, 255, 0.3);
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
   vertical-align: middle;
}

.version-status-icon {
   display: inline-flex;
   justify-content: center;
   align-items: center;
   min-width: 45px;
   height: 24px;
   padding: 0 8px;
   border-radius: 6px; 
   color: white;
   font-size: 12px;
   font-weight: bold;
   text-transform: none;
   white-space: nowrap;
   vertical-align: middle;
   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.activity-log-header {
    background-color: #ffffff !important; 
    border-bottom: none; 
    padding-bottom: 0.75rem;
}

.activity-log-header .modal-title {
    font-weight: bold;
    font-size: 1.25rem;
}

.modal-divider {
    margin: 0; 
    color: #dee2e6; 
}

#activityLogModal .modal-body {
    height: 600px; 
    overflow-y: auto; 
}

.btn-outline-info:focus,
.btn-outline-info:active,
.btn-outline-info.show {
   background-color: #00A0C1 !important;
   color: #ffffff !important;
   border-color: #00A0C1 !important;
}

.btn-outline-info.show .filter-text,
.btn-outline-info.show .filter-icon {
   color: #ffffff !important;
}

/* Premium Custom Checkboxes */
.custom-checkbox-input {
   position: absolute;
   opacity: 0;
   width: 0;
   height: 0;
   margin: 0;
   pointer-events: none;
}
.custom-checkbox {
   width: 20px;
   height: 20px;
   border: 2px solid #ced4da;
   border-radius: 4px;
   cursor: pointer;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   background-color: #fff;
   transition: all 0.2s ease;
   position: relative;
}
.custom-checkbox-input:checked + .custom-checkbox {
   background-color: #00A0C1;
   border-color: #00A0C1;
}
.custom-checkbox-input:checked + .custom-checkbox::after {
   content: '';
   position: absolute;
   width: 5px;
   height: 10px;
   border: solid white;
   border-width: 0 2px 2px 0;
   transform: rotate(45deg);
   top: 2px;
   left: 6px;
}
.custom-checkbox:hover {
   border-color: #00A0C1;
}
.custom-filter-dropdown-btn {
   background-color: #ffffff !important;
   color: #495057 !important;
   border: 1px solid #dee2e6 !important;
   transition: all 0.2s ease !important;
}
.custom-filter-dropdown-btn:hover,
.custom-filter-dropdown-btn:focus,
.custom-filter-dropdown-btn:active,
.custom-filter-dropdown-btn.show {
   background-color: #f8f9fa !important;
   color: #495057 !important;
   border-color: #ced4da !important;
   box-shadow: none !important;
}

/* Page Header Styles */
.ms-page-header {
   margin-bottom: 24px;
   padding: 20px 24px;
   background: linear-gradient(135deg, #ffffff 0%, #f4f9fb 100%);
   border: 1px solid rgba(0, 130, 152, 0.15);
   border-left: 5px solid #008298;
   border-radius: 12px;
   box-shadow: 0 4px 18px rgba(0, 78, 90, 0.05);
}

.ms-page-header__content {
   display: flex;
   align-items: center;
   gap: 16px;
}

.ms-page-header__icon {
   width: 44px;
   height: 44px;
   border-radius: 10px;
   background: rgba(0, 130, 152, 0.08);
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 1.15rem;
   color: #008298;
}

.ms-page-header__title {
   font-size: 1.45rem;
   font-weight: 800;
   color: #00363f;
   margin: 0;
   letter-spacing: -0.3px;
}

.ms-page-header__breadcrumb {
   font-size: 0.76rem;
   color: #557d84;
   font-weight: 700;
   text-transform: uppercase;
   letter-spacing: 0.8px;
   margin-bottom: 4px;
}

.ms-breadcrumb-sep {
   margin: 0 6px;
   color: rgba(0, 130, 152, 0.3);
}
</style>